const NETWORK_FAILURE_RE =
  /^(?:Failed to fetch|Load failed|NetworkError when attempting to fetch resource\.?|fetch failed|Network request failed)(?: \(.+\))?$/i

export function isNetworkRequestError(error) {
  if (!error || error.response || error.status || error.data) return false
  if (error.name !== 'FetchError' && error.name !== 'TypeError') return false
  const message = error.cause?.message || error.message?.match(/<no response> (.+)$/)?.[1] || error.message
  return NETWORK_FAILURE_RE.test(message || '')
}

// fire-and-forget 呼叫端（背景請求，沒有呼叫者可以承接被拋出的錯誤）用來判斷「這個失敗是否已由
// request 層呈現或上報」。回傳 true 代表再往上拋只會多一筆重複且 handled:no 的未捕捉 rejection，
// 可安全吞掉；回傳 false 者（資料契約異常、JS 回歸等）維持原未捕捉行為以利上報，不遮蔽真實問題。
//
// 判斷集中於此而非各呼叫端自行複製：新增失敗分類時只需改一處，避免某個呼叫端漏改後
// 靜默地把同一類失敗升級成未捕捉 rejection（CLIENT-PWA-SSR-16S / 1BV / 1TE）。
// 對應的標記由 plugins/01.request.js 的 catch 區塊寫入。
export function isRequestErrorAlreadySurfaced(error) {
  if (!error) return false
  // 後端業務錯誤（2xx 或 4xx body 帶 error payload）：已交付 _errorHandler 呈現（屏蔽 / 登出 / GA）
  if (error.isBusinessError) return true
  // 暫時性上游失敗（閘道 5xx / 逾時 / 限流）：已由 request 層以 warning 上報
  if (error.isTransientUpstreamError) return true
  // 連線層失敗（完全沒有回應）：已由 ERR_998 監控
  return isNetworkRequestError(error)
}
